export const calculateBMI = (langd: number, vikt: number): string => {
    if (vikt <= 0 || langd <= 0) {
        return "-";
    } else {
        const langdInMeters = langd / 100;

        return (vikt / (langdInMeters * langdInMeters)).toFixed(1).replace(".", ",");
    }
};
